import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Print = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="print icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M5 2C5 0.89543 5.89543 0 7 0H17C18.1046 0 19 0.895431 19 2V5H5V2Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7C0.895431 7 0 7.89543 0 9V16C0 17.1046 0.89543 18 2 18H5V22C5 23.1046 5.89543 24 7 24H17C18.1046 24 19 23.1046 19 22V18H22C23.1046 18 24 17.1046 24 16V9C24 7.89543 23.1046 7 22 7H2ZM8 14V21H16V14H8Z"
    />
  </svg>
)
